import React, { useEffect } from "react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Pricing from "../components/home/Pricing";
import WhyChoose from "../components/home/WhyChoose";

const PricingPlan = () => {
  useEffect(() => {
    document.title = "Pricing Plan – Moggies & Doggies Veterinary Care";
  }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner
          title="Pricing Plan"
          subtitle="Explore Our Personalized Veterinary Care Pricing Plans"
          crumbs={["Pricing Plan"]}
        />
        <Pricing />
        <WhyChoose />
      </main>
      <Footer />
    </div>
  );
};

export default PricingPlan;
